import { GameServices } from '../../services/game-services';
import { StartViewModel } from '../components/start-view-model';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { BoardScalingMetrics } from '../../services/game-metrics-service';
import { RoundInfoDividerViewModel } from './round-info-divider-view-model';
import { PlayerBettingBoxViewModel } from '../player/player-betting-box-view-model';
import { CroupierBettingBoxViewModel } from '../croupier/croupier-betting-box-view-model';
import { CardDeckViewModel } from './card-deck-view-model';
import { ResultsViewModel } from './results-view-model';
import { ChipPickerViewModel } from '../chips/picker/chip-picker-view-model';

export class GameBoardViewModel {
  public get logicEventQueue$() {
    return this.gameServices.blackjackGameRunner.logicEventQueue$;
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }

  public readonly startViewModel: StartViewModel;
  public readonly playerBettingBoxViewModel: PlayerBettingBoxViewModel;
  public readonly croupierBettingBoxViewModel: CroupierBettingBoxViewModel;
  public readonly cardDeckViewModel: CardDeckViewModel;
  public readonly chipPickerViewModel: ChipPickerViewModel;
  public readonly roundInfoDividerViewModel: RoundInfoDividerViewModel;
  public readonly resultsViewModel: ResultsViewModel;

  constructor(private gameServices: GameServices) {
    this.startViewModel = new StartViewModel(gameServices);
    this.playerBettingBoxViewModel = new PlayerBettingBoxViewModel(gameServices);
    this.croupierBettingBoxViewModel = new CroupierBettingBoxViewModel(gameServices);
    this.cardDeckViewModel = new CardDeckViewModel(gameServices);
    this.chipPickerViewModel = new ChipPickerViewModel(gameServices);
    this.roundInfoDividerViewModel = new RoundInfoDividerViewModel(gameServices);
    this.resultsViewModel = new ResultsViewModel(gameServices);
  }

  public showStartButton(showButton: boolean) {
    this.startViewModel.showStartButton(showButton);
  }

  public resetGameScene() {
    this.playerBettingBoxViewModel.resetGameScene();
    this.croupierBettingBoxViewModel.resetGameScene();
    this.cardDeckViewModel.resetGameScene();
    this.chipPickerViewModel.resetGameScene();
    this.roundInfoDividerViewModel.resetGameScene();
  }

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): BoardScalingMetrics {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  // TODO: Disable auto finish until we can create an alternative solution
  /*
  public awaitAutoFinish(
    roundState: RoundState,
    isOutOfChips: boolean,
    isGameCompleted: boolean,
  ): void {
    if (roundState !== RoundState.Continue) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      return;
    }

    this.timeoutId = setTimeout(() => {
      const canAutoFinish = isOutOfChips || isGameCompleted;
      if (canAutoFinish) {
        // Auto click the continue button to reset the round and finish the game
        this.gameServices.blackjackGameRunner.currentGame?.continueRound(false);
      }
    }, 1500);
  }*/
}
